import { BaseComponent } from './../../../../core/abstracts/baseComponent';
import { BenefitsState, initBenefitsDependentForm } from './../../../../core/store/benefits/benefits.reducer';
import { BenefitPlanModel, BenefitPlanEnrollmentSetModel, BenefitPlanUserWithEnrollmentSetModel, BenefitClassModel, BenefitPlanEnrollmentModel, BenefitsDependentModel, BenefitPlanTypeModel } from './../../../../models/benefitsModels';
import { PagingResultsModel } from '../../../../models/pagingResultsModel';
import { Component, OnInit, signal, computed } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../../../../core/store';
import { Actions, ofType } from '@ngrx/effects';
import { Router } from '@angular/router';
import { MultiSelect } from 'primeng/multiselect';
import { AlertService } from '../../../../shared/services/alert.service';
import { deepClone, downloadFile, formatDateString, getAllControlsErrors, getDateString, getDateWithOffset, getShortDateFormatted, getTimeStampString, markFormGroupTouched, updateFormGroupValidity } from '../../../../helpers/utils';
import { deleteBenefitsDependentSuccess, deleteBenefitsPlans, deleteBenefitsPlansSuccess, downloadEnrollmentSetSignedForms, downloadEnrollmentSetSignedFormsSuccess, exportManageEmployeesListToExcel, exportManageEmployeesListToExcelSuccess, loadAllBenefitPlans, loadBenefitClasses, loadBenefitPlanUserWithEnrollmentSet, loadBenefitsPlans, loadBenfitPlanTypes, saveBenefitsDependent, saveBenefitsDependentSuccess, updateBenefitsDependentForm } from '../../../../core/store/benefits/benefits.actions';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { of, catchError, map, tap } from 'rxjs';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { BenefitsService } from '../../../../core/services/benefits.service';
import { errorHappened } from '../../../../core/store/profile/profile.actions';

@Component({
    selector: 'app-list-benefits-employees',
    templateUrl: './list-benefits-employees.component.html',
    styleUrls: ['./list-benefits-employees.component.scss'],
    standalone: false
})
export class ListBenefitsEmployeesComponent extends BaseComponent implements OnInit {

  benefitsEmployeesList: PagingResultsModel<BenefitPlanUserWithEnrollmentSetModel>;
  canEdit: boolean;
  loadingBenefitsEmployeesList = false;
  filter: any = { first: 0 };
  downloadingZipFile: boolean = false;
  zipDownloadEmployee: string = "ZipFile";
  canViewAllColumns: boolean;
  canView: boolean;

  employeeNameFilter;
  ssnFilter;
  enrolledPlanNameFilter;
  enrolledPlanCarrierFilter;
  declinedPlanIDFilter;
  enrollmentStatusFilter = 'Active';
  yearFilter;
  signedFilter;
  classesFilter = [1, 2];
  openedPlans = {};
  openedDeclineds = {};
  filterTimeout;

  rowsAmount = 20;

  yesNoAllOptions = [
    { label: 'All', value: null },
    { label: 'Yes', value: 'true' },
    { label: 'No', value: 'false' },
  ];
  yearEnrollmentOptions= [
    { label: 'All', value: null }    
  ];
  enrollmentStatusOptions = [
    { label: 'All', value: null },
    { label: 'Active', value: 'Active' },
    { label: 'Planned', value: 'Planned' },
    { label: 'Expired', value: 'Expired' },
    { label: 'Incomplete', value: 'Incomplete' },
    { label: 'Pending', value: 'Pending' },
   // { label: 'Deactivated', value: 'Deactivated' },
   // { label: 'Declined', value: 'Declined' },
  ];

  plansOptions = [];
  planTypesOptions = [];
  planCarriersOptions = [];

  allBenefitPlanTypes: BenefitPlanTypeModel[];
  allBenefitPlans: BenefitPlanModel[];
  benefitClasses: BenefitClassModel[];
  classOptions;


  benefitsDependentEdit: BenefitsDependentModel;
  benefitsDependentForm: UntypedFormGroup;


  relationshipOptions = [
    { label: 'Spouse', value: 'Spouse' },
    { label: 'Child', value: 'Child' },
    { label: 'Legal Guardian', value: 'Legal Guardian' },
  ];

  suffixOptions = [
    { label: '', value: '' },
    { label: 'CPA', value: 'CPA' },
    { label: 'CRNP', value: 'CRNP' },
    { label: 'D.O.', value: 'D.O.' },
    { label: 'DDS', value: 'DDS' },
    { label: 'DMD', value: 'DMD' },
    { label: 'II', value: 'II' },
    { label: 'III', value: 'III' },
    { label: 'IV', value: 'IV' },
    { label: 'JD', value: 'JD' },
    { label: 'Jr.', value: 'Jr.' },
    { label: 'MD', value: 'MD' },
    { label: 'PA-C', value: 'PA-C' },
    { label: 'PhD', value: 'PhD' },
    { label: 'RN', value: 'RN' },
    { label: 'Sr.', value: 'Sr.' },
    { label: 'V', value: 'V' },

  ];

  genderOptions: SelectItem[] = [
    { label: 'Male', value: 1 },
    { label: 'Female', value: 0 }];




  enrollmentSetEdit: BenefitPlanEnrollmentSetModel;
  enrollmentSetForm: UntypedFormGroup;
  enrollmentSetDependents: SelectItem[];

  lifeEventOptions: SelectItem[] = [
    { label: 'Open Enrollment', value: 1 },
    { label: 'New Hire', value: 2 },
    { label: 'Marriage', value: 3 },
    { label: 'Divorce/Legal Separation/Annulment', value: 4 },
    { label: 'PT to FT Employment', value: 5 },
    { label: 'Loss of other coverage', value: 6 },
    { label: 'Other', value: 7 },
    { label: 'New Baby Born', value: 8 }
  ];

  coverageLevels: SelectItem[] = [
    { label: 'EMP	- Employee', value: 1 },
    { label: 'ESP	- Employee + Spouse', value: 2 },
    { label: 'ECH	- Employee + Children', value: 3 },
    { label: 'FAM	- Employee + Family', value: 4 },
    { label: 'E1D	- Employee + 1', value: 5 }
  ];
  declineReasons: SelectItem[] = [
    { label: 'Covered under spouse\'s plan', value: 1 },
    { label: 'Covered under parent/guardian\'s plan', value: 2 },
    { label: 'Covered under Medicare and/or Medicaid', value: 3 },
    { label: 'Covered under individual plan', value: 4 },
    { label: 'Covered under Tricare', value: 5 },
    { label: 'Covered under another employer\'s plan', value: 6 },
    { label: 'Covered under retiree plan', value: 7 },
    { label: 'Cost', value: 8 },
    { label: 'Not Interested', value: 9 },
    { label: 'Ineligible for this plan', value: 10 },
    { label: 'Other', value: 11 }
  ];
  loadingExcel: boolean = false;

  totalRecords = signal<number>(0);
  dropdownOptions = computed(() => {
    var total = this.totalRecords();
    return [
      { label: '20', value: 20 },
      { label: '50', value: 50 },
      { label: '100', value: 100 },
      { label: '200', value: 200 },
      { label: '500', value: 500 },
      { label: 'All', value: total > 0 ? total : 20 } 
    ];
  });

  constructor(
    private actions$: Actions,
    private alertService: AlertService,
    private store: Store<State>,
    private router: Router,
    private confirmationService: ConfirmationService,
    private formBuilder: UntypedFormBuilder,
    private benefitsService: BenefitsService,
  ) {
    super();
    var d = getDateWithOffset(90);

    for (var i = d.getFullYear(); i >= 2022; i--) {
      this.yearEnrollmentOptions.push({ label: i.toString(), value: i.toString() });
    }
  }
   
  ngOnInit() {
    this.subs.push(
      this.store.select(s => s.accountState.user?.permissionIDs).subscribe(permissionIDs => {
        this.canEdit = permissionIDs && !!permissionIDs.find(p => p === 6050);
        this.canViewAllColumns = permissionIDs && !!permissionIDs.find(p => p === 6050); //6050 and 3142 allow access to page. 3142 has limited visibility
        this.canView = permissionIDs && !!permissionIDs.find(p => p === 6050 || p === 3142);
      }),
      this.store.select(s => s.benefitsState.benefitPlanUserWithEnrollmentSetList).subscribe(benefitPlanUserWithEnrollmentSetList => {
        if (benefitPlanUserWithEnrollmentSetList) {
          this.benefitsEmployeesList = deepClone(benefitPlanUserWithEnrollmentSetList);
          this.totalRecords.set(benefitPlanUserWithEnrollmentSetList.totalRecords);
          // Remove Perk from the list
          this.benefitsEmployeesList.result.forEach(employeeWithBenefits => {
            if (employeeWithBenefits.enrollmentSet) {
              employeeWithBenefits.enrollmentSet.enrollments = employeeWithBenefits.enrollmentSet.enrollments.filter(x => x.benefitPlan.benefitPlan.benefitPlanTypeLabel !== 'Employee Perk');
            }
          })
        }
      }),
      this.store.select(s => s.benefitsState.benefitPlanTypesList).subscribe(benefitPlanTypesList => {
        if (benefitPlanTypesList) {
          this.allBenefitPlanTypes = benefitPlanTypesList;
          this.planTypesOptions = benefitPlanTypesList.filter(x => x.planTypeName !== 'Employee Perk').map(x => ({ label: x.planTypeName, value: x.id }));
          this.planTypesOptions.unshift({ label: 'All', value: null });
        }
      }),
      this.store.select(s => s.benefitsState.allBenefitPlans).subscribe(allBenefitPlans => {
        if (allBenefitPlans) {
          this.allBenefitPlans = allBenefitPlans;
          allBenefitPlans = allBenefitPlans.filter(x => x.benefitPlanTypeLabel !== 'Employee Perk');
          this.plansOptions = allBenefitPlans.map(x => ({ label: x.planName, value: x.planName }));
          this.plansOptions.unshift({ label: 'All', value: null });
          this.planCarriersOptions = [];
          allBenefitPlans.forEach(plan => {
            if (!this.planCarriersOptions.find(x => x.value == plan.carrier)) {
              this.planCarriersOptions.push({ label: plan.carrier, value: plan.carrier });
            }
          });
          this.planCarriersOptions.unshift({ label: 'All', value: null });

        }
      }),
      this.store.select(s => s.benefitsState.loadingBenefitPlanUserWithEnrollmentSetList).subscribe(loadingBenefitPlanUserWithEnrollmentSetList => {
        this.loadingBenefitsEmployeesList = loadingBenefitPlanUserWithEnrollmentSetList;
      }),
      this.store.select(s => s.benefitsState.benefitClasses).subscribe(benefitClasses => {
        if (benefitClasses) {
          this.benefitClasses = benefitClasses;
          this.classOptions = this.benefitClasses.map(x => ({ label: x.class, value: x.id }));
          this.classOptions.push({ label: 'Not Set', value: 0 });
          if (benefitClasses.length) {
            this.classesFilter = this.benefitClasses.filter(x => x.class !== 'Variable Hour Ineligible').map(x => (x.id));
          }
        }
      }),

      this.store.select(s => s.benefitsState.loadingManageEmployeesListToExcel).subscribe(loadingManageEmployeesListToExcel => {
        this.loadingExcel = loadingManageEmployeesListToExcel;
      }),

      this.actions$.pipe(
        ofType(downloadEnrollmentSetSignedFormsSuccess),
        tap(action => {
          downloadFile(action.doc, this.getZipFileName());
        })
      ).subscribe(),
      this.actions$.pipe(
        ofType(exportManageEmployeesListToExcelSuccess),
        tap(action => {
          downloadFile(action.doc, 'EmployeeBenefitsList.xlsx');
        })
      ).subscribe(),


      this.store.select(s => s.benefitsState.benefitsDependentInfo).subscribe(benefitsDependentInfo => {
        if (benefitsDependentInfo) {
          this.benefitsDependentEdit = benefitsDependentInfo;
        }
      }),

      this.actions$.pipe(
        ofType(saveBenefitsDependentSuccess),
        tap(action => {
          this.alertService.success('Benefits Dependent saved!');
          this.loadPage(this.filter);
          this.benefitsDependentEdit = null;
        })
      ).subscribe(),

      this.actions$.pipe(
        ofType(deleteBenefitsDependentSuccess),
        tap(action => {
          this.alertService.success('Benefits Dependent removed!');
          this.loadPage(this.filter);
        })
      ).subscribe(),



    );

    this.store.dispatch(loadBenefitClasses());
    this.store.dispatch(loadBenfitPlanTypes());
    this.store.dispatch(loadAllBenefitPlans());


  }

  getZipFileName() {
    let fileName = this.zipDownloadEmployee + "_" + getTimeStampString() + ".zip";

    return fileName;
  }

  loadPage(event) {
    if (!this.loadingBenefitsEmployeesList) {
      this.loadingBenefitsEmployeesList = true;
      this.filter = deepClone(event);

      this.filter.filters.employeeNameFilter = { Name: 'employeeNameFilter', Value: { value: this.employeeNameFilter } };
      this.filter.filters.ssnFilter = { Name: 'ssnFilter', Value: { value: this.ssnFilter } };
      this.filter.filters.enrolledPlanNameFilter = { Name: 'enrolledPlanNameFilter', Value: { value: this.enrolledPlanNameFilter } };
      this.filter.filters.enrolledPlanCarrierFilter = { Name: 'enrolledPlanCarrierFilter', Value: { value: this.enrolledPlanCarrierFilter } };
      this.filter.filters.declinedPlanIDFilter = { Name: 'declinedPlanIDFilter', Value: { value: this.declinedPlanIDFilter } };
      this.filter.filters.enrollmentStatusFilter = { Name: 'enrollmentStatusFilter', Value: { value: this.enrollmentStatusFilter } };
      this.filter.filters.signedFilter = { Name: 'signedFilter', Value: { value: this.signedFilter } };
      this.filter.filters.yearFilter = { Name: 'yearFilter', Value: { value: this.yearFilter } };
      this.filter.filters.classesFilter = { Name: 'classesFilter', Value: { value: '' + this.classesFilter + '' } };


      if (this.filterTimeout) {
        clearTimeout(this.filterTimeout);
      }
      this.store.dispatch(loadBenefitPlanUserWithEnrollmentSet({
        filter: deepClone(this.filter)
      }));
    }
  }


  changedFilters() {
    if (this.filterTimeout) {
      clearTimeout(this.filterTimeout);
    }
    this.filterTimeout = setTimeout(() => {
      this.filter.first = 0;
      this.loadPage(this.filter);
    }, 1000);

  }
  getAllDependents(enrollmentSet: BenefitPlanEnrollmentSetModel) {
    const distinctDependents = [];
    for (const enrollment of enrollmentSet.enrollments) {
      for (const dependent of enrollment.dependents) {
        if (!distinctDependents.find(x => x.id === dependent.id)) {
          distinctDependents.push(dependent);
        }
      }
    }

    return distinctDependents;
  }


  getEnrollmentLifeChangingEvent(enrollmentSet: BenefitPlanEnrollmentSetModel) {
    if (!enrollmentSet )
      return '';

    if (enrollmentSet.lifeChangingEventID == 1)
      return `Open Enrollment ${enrollmentSet.plansYear}`;

    if (enrollmentSet.lifeChangingEventOther)
      return `${enrollmentSet.lifeChangingEventOther} ${getShortDateFormatted(new Date(enrollmentSet.lifeChangingEventDate))}`;
    
    if (enrollmentSet.lifeChangingEventID) {
      var lifeChangingEvent = this.lifeEventOptions.find(x => x.value === enrollmentSet.lifeChangingEventID);
      if (lifeChangingEvent) {
        if (enrollmentSet.lifeChangingEventDate)
          return lifeChangingEvent.label + ' on ' + getShortDateFormatted(new Date(enrollmentSet.lifeChangingEventDate));
        else
          return lifeChangingEvent.label
      }
    }
    if (enrollmentSet.plansYear)
      return `Enrollment ${enrollmentSet.plansYear}`;
    return '';

  }

  getEnrollmentDates(enrollmentSet: BenefitPlanEnrollmentSetModel) {
    //               {{employeeWithBenefits.enrollmentSet?.activatedDate | date:'shortDate' }}
    if (!enrollmentSet)
      return '';
    
    
    var periods = [];
    if (enrollmentSet.enrollments && enrollmentSet.enrollments.length) {

      for (var en of enrollmentSet.enrollments) {

        let dateStart = new Date(en.dateStart);
        let dateEnd = new Date(en.dateEnd);
        var eP = '';

        if (dateStart.getMonth() == 0 && dateStart.getDate() == 1
          && (!en.dateEnd || (dateEnd.getFullYear() == dateStart.getFullYear() && dateEnd.getMonth() == 11 && dateEnd.getDate() == 31))) {
          eP = `${dateStart.getFullYear()}`
        }
        else if (!en.dateEnd || (dateEnd > new Date() && dateEnd.getFullYear() == dateStart.getFullYear() && dateEnd.getMonth() == 11 && dateEnd.getDate() == 31)) {
          eP = `${getShortDateFormatted(dateStart)}`;
        } else {
          eP = `${getShortDateFormatted(dateStart)} - ${getShortDateFormatted(dateEnd)}`;
        }

        if (periods.indexOf(eP) == -1)
          periods.push(eP);
      }
    }
    else if (enrollmentSet.declineds && enrollmentSet.declineds.length) {

      for (var de of enrollmentSet.declineds) {

        let dateStart = new Date(de.dateStart);
        let dateEnd = new Date(de.dateEnd);
        var eP = '';

        if (dateStart.getMonth() == 0 && dateStart.getDate() == 1
          && (!de.dateEnd || (dateEnd.getFullYear() == dateStart.getFullYear() && dateEnd.getMonth() == 11 && dateEnd.getDate() == 31))) {
          eP = `${dateStart.getFullYear()}`
        }
        else if (!de.dateEnd || (dateEnd > new Date() && dateEnd.getFullYear() == dateStart.getFullYear() && dateEnd.getMonth() == 11 && dateEnd.getDate() == 31)) {
          eP = `${getShortDateFormatted(dateStart)}`;
        } else {
          eP = `${getShortDateFormatted(dateStart)} - ${getShortDateFormatted(dateEnd)}`;
        }

        if (periods.indexOf(eP) == -1)
          periods.push(eP);
      }
    }
    if (!periods.length)
      return enrollmentSet.plansYear;

    return periods.join(', ');
  }

  getTotalCost(enrollmentSet: BenefitPlanEnrollmentSetModel) {
    return enrollmentSet.enrollments.reduce((sum, enrollment) => {
      const cost = enrollment.costPerPayPeriod;
      return sum + Number(cost);
    }, 0);
  }
  getTotalEmployerCost(enrollmentSet: BenefitPlanEnrollmentSetModel) {
    return enrollmentSet.enrollments.reduce((sum, enrollment) => {
      const cost = enrollment.employerContribution;
      return sum + Number(cost);
    }, 0);
  }
  getClassLabel(id?: number) {
    if (!id) {
      return 'Not Set';
    }
    const benefitClass = this.benefitClasses.find(x => x.id === id);
    if (benefitClass) {
      return benefitClass.class;
    }
    return '';
  }

  openPlan(obj: BenefitPlanUserWithEnrollmentSetModel) {
    this.openedPlans[obj.user.id] = !this.openedPlans[obj.user.id];
  }
  isPlanOpen(obj: BenefitPlanUserWithEnrollmentSetModel) {
    return !!this.openedPlans[obj.user.id];
  }
  openDeclined(obj: BenefitPlanUserWithEnrollmentSetModel) {
    this.openedDeclineds[obj.user.id] = !this.openedDeclineds[obj.user.id];
  }
  isDeclinedOpen(obj: BenefitPlanUserWithEnrollmentSetModel) {
    return !!this.openedDeclineds[obj.user.id];

  }

  downloadSignDocumentZipFile(model: BenefitPlanUserWithEnrollmentSetModel) {
    if (this.downloadingZipFile) {
      return;
    }

    this.zipDownloadEmployee = model.user.firstName + "_" + model.user.lastName;

    this.store.dispatch(downloadEnrollmentSetSignedForms({ enrollmentSetId: model.enrollmentSet.id }));
  }

  exportToExcel() {
    this.filter = deepClone(this.filter);
    this.store.dispatch(exportManageEmployeesListToExcel({
      filter: this.filter
    }));
  }



  editDependent(benefitsDependent: BenefitsDependentModel) {
    
    this.benefitsDependentEdit = benefitsDependent;
    this.initDependentForm();
    
  }

  initDependentForm() {
    this.benefitsDependentForm = initBenefitsDependentForm(this.benefitsDependentEdit);
    this.subs.push(
      this.benefitsDependentForm.valueChanges.subscribe(formValues => {
        const formErrors = getAllControlsErrors(this.benefitsDependentForm);
        this.store.dispatch(updateBenefitsDependentForm({ benefitsDependentValues: formValues, formErrors }));
      }));
  }


  saveDependent() {
    console.debug(this.benefitsDependentForm.value);
    updateFormGroupValidity(this.benefitsDependentForm);
    if (this.benefitsDependentForm.valid) {
      this.store.dispatch(saveBenefitsDependent({ benefitsDependent : this.benefitsDependentEdit }));
    } else {
      markFormGroupTouched(this.benefitsDependentForm);
    }
  }


  editEnrollmentSet(enrollmentSet: BenefitPlanEnrollmentSetModel) {

    if (!this.enrollmentSetForm)
      this.initEnrollmentSetForm();

    this.enrollmentSetEdit = enrollmentSet;


    this.loadEnrollmentSetForm()
  }
  
  initEnrollmentSetForm() {
    this.enrollmentSetForm = this.formBuilder.group(
      {
        lifeChangingEventOther: ['', [Validators.maxLength(1000)]],
        lifeChangingEventID: [],
        lifeChangingEventDate: [],
        activatedDate: [],

        enrollments: this.formBuilder.array([]),
        declineds: this.formBuilder.array([])
      });


  }


  get enrollmentsFormArray() {
    if (this.enrollmentSetForm)
      return this.enrollmentSetForm.controls["enrollments"] as UntypedFormArray;
    return null;
  }
  get declinedsFormArray() {
    if (this.enrollmentSetForm)
      return this.enrollmentSetForm.controls["declineds"] as UntypedFormArray;
    return null;
  }

  loadEnrollmentSetForm() {

    if (!this.enrollmentSetEdit)
      return;
    this.enrollmentSetForm.clearValidators();

    var data = {
      lifeChangingEventID: this.enrollmentSetEdit.lifeChangingEventID ?? 1,
      lifeChangingEventOther: this.enrollmentSetEdit.lifeChangingEventOther,
      lifeChangingEventDate: this.enrollmentSetEdit.lifeChangingEventDate ? new Date(this.enrollmentSetEdit.lifeChangingEventDate) : null, 
      activatedDate: this.enrollmentSetEdit.activatedDate ? new Date(this.enrollmentSetEdit.activatedDate) : null,
      
      
      enrollments: [],
      declineds: []
    };

    this.enrollmentsFormArray.clear();
    if (this.enrollmentSetEdit.enrollments)
      this.enrollmentSetEdit.enrollments.forEach(t => {
        var item: UntypedFormGroup = this.formBuilder.group({
          id: [0], 
          benefitPlanID: [0],
          benefitPlan: [],
          benefitPlanTypeID: [],
          benefitPlanType: [],
          coverageLevelID: [],
          dateStart: [null, [Validators.required]],
          dateEnd: [],
          costPerPayPeriod: [],
          employerContribution: [],
          employeePerPayElection: [],
          deleted: [false],
          generateNewDocumentToSign: [false],
          dependentIds: [],
          dependents: [],
          //dependentIds: this.formBuilder.array([])
        });
        this.enrollmentsFormArray.push(item);

        data.enrollments.push({
          id: t.id,
          benefitPlanID: t.benefitPlanID,
          benefitPlan: t.benefitPlan.benefitPlan.planName,
          benefitPlanTypeID: t.benefitPlan.benefitPlan.benefitPlanTypeID,
          benefitPlanType: t.benefitPlan.benefitPlan.benefitPlanTypeLabel,
          coverageLevelID: t.coverageLevelID,
          dateStart: t.dateStart ? (new Date(t.dateStart)) : null,
          dateEnd: t.dateEnd ? (new Date(t.dateEnd)) : null,
          costPerPayPeriod: t.costPerPayPeriod,
          employerContribution: t.employerContribution,
          employeePerPayElection: t.employeePerPayElection,
          deleted: false,
          generateNewDocumentToSign: false,
          dependentIds: t.dependents.map(d => d.id.toString())
          //dependents: t.dependents
        });
      });


    this.declinedsFormArray.clear();
    if (this.enrollmentSetEdit.declineds)
      this.enrollmentSetEdit.declineds.forEach(t => {
        var item: UntypedFormGroup = this.formBuilder.group({
          id: [0],
          benefitPlanTypeID: [],
          benefitPlanType: [],
          declineReasonID: [],
          declineReason: [],
          otherReason: [],
          dateStart: [null, [Validators.required]],
          dateEnd: [],
          deleted: [false]
        });
        this.declinedsFormArray.push(item);

        data.declineds.push({
          id: t.id,
          benefitPlanTypeID: t.benefitPlanTypeID,
          benefitPlanType: t.benefitPlanType.planTypeName,
          declineReasonID: t.declineReasonID,
          declineReason: t.declineReason.reason,
          otherReason: t.otherReason,
          dateStart: t.dateStart ? (new Date(t.dateStart)) : null,
          dateEnd: t.dateEnd ? (new Date(t.dateEnd)) : null,
          deleted: false
        });
      });
    //console.debug(data);
    this.enrollmentSetDependents = this.getAllDependents(this.enrollmentSetEdit).map(d => { return { value: d.id.toString(), label: `${d.firstName} ${d.lastName} (${d.relationship})` } as SelectItem; });
    //this.enrollmentSetDependents = this.getAllDependents(this.enrollmentSetEdit).map(d => { return { value: d.id.toString(), label: `${d.firstName}` } as SelectItem; });
   // console.debug(this.enrollmentSetEdit);
    this.enrollmentSetForm.patchValue(data);
   
  }


  saveEnrollmentSet() {

    updateFormGroupValidity(this.enrollmentSetForm);
    if (this.enrollmentSetForm.valid) {
      try {
        var formValue = this.enrollmentSetForm.getRawValue();
        //console.debug(formValue);

        var enrollments = [];
        var allDependents = this.getAllDependents(this.enrollmentSetEdit);

        for (var fE of formValue.enrollments) {
          var enrollment = this.enrollmentSetEdit.enrollments.find(x => x.id == fE.id)
          if (!enrollment) {
            enrollment = {
              id: 0,
              benefitPlanID: fE.benefitPlanID,
            } as BenefitPlanEnrollmentModel;
            this.enrollmentSetEdit.enrollments.push(enrollment);
          }
          enrollment.dateStart = (fE.dateStart) ? getDateString(new Date(fE.dateStart)) : null;
          enrollment.dateEnd = (fE.dateEnd) ? getDateString(new Date(fE.dateEnd)) : null;
          enrollment.costPerPayPeriod = fE.costPerPayPeriod;
          enrollment.employeePerPayElection = fE.employeePerPayElection;
          enrollment.employerContribution = fE.employerContribution;
          enrollment.coverageLevelID = fE.coverageLevelID;
          enrollment.deleted = fE.deleted;
          enrollment.generateNewDocumentToSign = fE.generateNewDocumentToSign;

          var fDependents = allDependents.filter(x => {
            return fE.dependentIds.indexOf(x.id.toString()) !== -1;
          });
          enrollment.dependents = fDependents;
        }

        for (var fE of formValue.declineds) {
          var declined = this.enrollmentSetEdit.declineds.find(x => x.id == fE.id)
          if (!declined) {
            declined = {
              id: 0,
              benefitPlanID: fE.benefitPlanID,
            } as BenefitPlanEnrollmentModel;
            this.enrollmentSetEdit.enrollments.push(enrollment);
          }
          declined.dateStart = (fE.dateStart) ? getDateString(new Date(fE.dateStart)) : null;
          declined.dateEnd = (fE.dateEnd) ? getDateString(new Date(fE.dateEnd)) : null;
          declined.declineReasonID = fE.declineReasonID;
          declined.otherReason = fE.otherReason;
          declined.deleted = fE.deleted;
          
        }

        this.enrollmentSetEdit.isOtherUser = true;
        this.enrollmentSetEdit.lifeChangingEventID = formValue.lifeChangingEventID;
        this.enrollmentSetEdit.lifeChangingEventOther = formValue.lifeChangingEventOther;
        this.enrollmentSetEdit.lifeChangingEventDate = (formValue.lifeChangingEventDate) ? getDateString(new Date(formValue.lifeChangingEventDate)) : null;
        this.enrollmentSetEdit.activatedDate = (formValue.activatedDate) ? getDateString(new Date(formValue.activatedDate)) : null;

        //  console.debug(this.enrollmentSetEdit);

        //this.store.dispatch(saveBenefitsEnrollment({ enrollmentSet: this.enrollmentSetEdit }));
        
        this.benefitsService.saveEmployeeEnrollmentSet(this.enrollmentSetEdit).pipe(
          map(enrollmentSet => {
            this.alertService.success('Enrolled Plans saved!');
            this.loadPage(this.filter);
            this.enrollmentSetEdit = null;
  
          }),
          catchError(err => {
            
            return of(errorHappened({ err }));
          })
        ).subscribe();
          
      } catch (ex) {
        this.alertService.error(ex);
      }
    } else {
      markFormGroupTouched(this.enrollmentSetForm);
    }
  }


  canViewHiredEmployeeFile(item: BenefitPlanUserWithEnrollmentSetModel) {
    
    if (item == null)
      return false;

    if (item.employee != null &&
      item.employee.trainingStartDate != null &&
      new Date(item.employee.trainingStartDate) < new Date())
      return false;


    return true;
  }

  seeUserDetails(item: BenefitPlanUserWithEnrollmentSetModel) {
    this.router.navigate(['/employee-file/detail/' + item.user.id]);
  }

  getIncompletePlanTypes(item: BenefitPlanUserWithEnrollmentSetModel) {

    let incompletePlans = [] as BenefitPlanTypeModel[];


    this.allBenefitPlanTypes.forEach(planType => {
      if (item.enrollmentSet.declineds.find(x => x.benefitPlanTypeID == planType.id))
        return;
      if (item.enrollmentSet.enrollments.find(x => x.benefitPlan.benefitPlan.benefitPlanTypeID == planType.id))
        return;
      if (!planType.allowDecline)
        return;

      if (!this.allBenefitPlans.find(x => x.benefitPlanTypeID == planType.id
        && ( (!x.dateStart && !x.dateEnd ) || x.active )
        && (!x.dateStart || new Date(x.dateStart).getFullYear() <= item.enrollmentSet.plansYear)
        && (!x.dateEnd || new Date(x.dateEnd).getFullYear() >= item.enrollmentSet.plansYear)
        //        && (!x.dateEnd || new Date(x.dateEnd) < item.enrollmentSet.activatedDate
        && (!x.dependOnPlanID || item.enrollmentSet.enrollments.find(y => y.benefitPlanID == x.dependOnPlanID))
        ))
        return;
      
      

      incompletePlans.push(planType);
    });

    return incompletePlans;
  }
}

